import { render } from "./SoccerTeamInsights.vue?vue&type=template&id=aeae4988&scoped=true"
import script from "./SoccerTeamInsights.vue?vue&type=script&lang=js"
export * from "./SoccerTeamInsights.vue?vue&type=script&lang=js"

import "./SoccerTeamInsights.vue?vue&type=style&index=0&id=aeae4988&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeae4988"]])

export default __exports__